const required =
  (msg = 'Required value.') =>
  (value: string) =>
    !!value || msg;

export default required;
